/** The sign-in page. Dependency-free so routes and hooks can import it without axios. */
export const SIGN_IN_PATH = "/auth/log-in";
